import { Navigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { useRegistrationRouteState } from '../features/registration/model';
import { useResolvedAuthenticatedPath } from '../shared/hooks/use-employee-session';
import {
  RegistrationProgress,
  ViewportFrame,
  ViewportPage,
} from '../shared/ui';

const ProgressSlot = styled.div`
  margin-bottom: ${({ theme }) => theme.scale.px(47)};
`;

const ContentSlot = styled.div.attrs({
  'data-ui': 'registration-layout-content-slot',
})`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
`;

export function RegistrationLayout() {
  const redirectPath = useResolvedAuthenticatedPath();
  const progressState = useRegistrationRouteState();

  if (redirectPath === null) {
    return null;
  }

  if (
    redirectPath === '/login' ||
    redirectPath === '/unlock' ||
    redirectPath === '/settings/pin' ||
    redirectPath === '/home'
  ) {
    return <Navigate replace to={redirectPath} />;
  }

  return (
    <ViewportPage dataUi="registration-layout-page">
      <ViewportFrame
        dataUi="registration-layout-frame"
        paddingBottomPx={25}
        paddingLeftPx={0}
        paddingRightPx={0}
        paddingTopPx={14}
      >
        <ProgressSlot>
          <RegistrationProgress
            progressPercent={progressState.progressPercent}
            progressPercentLabel={progressState.progressPercentLabel}
            progressEtaTranslationKey={progressState.progressEtaTranslationKey}
          />
        </ProgressSlot>

        <ContentSlot>
          <Outlet />
        </ContentSlot>
      </ViewportFrame>
    </ViewportPage>
  );
}
